/**
 * @file       Notification Constants
 * @version    1.0.0
 * @desc       Toast and dialog result-message display times. Toasts have
 *             no close button, so every toast must hide on its own.
 */

/**
 * Display time in milliseconds for operation results
 */
const NOTIFICATION_TIMEOUT = Object.freeze(
{
    INFO: 1000,
    SUCCESS: 8000,
    ERROR: 11000
});

export
{
    NOTIFICATION_TIMEOUT
};
